import serverInterface from 'server-interface';

class Cache {

  constructor() {

    this.disabled = true;
    this.userPropertyNames = [];
    this.propertyNameValuesMap = {};

  }

  clearUserPropertyNames() {

    this.userPropertyNames = [];

  }

  async getUserPropertyNames() {

    if (this.disabled === false && this.userPropertyNames.length === 0) {
      return this.userPropertyNames;
    }

    this.userPropertyNames = await serverInterface.startup.analytics.getUserPropertyNames();

    return this.userPropertyNames;

  }

  async getUserPropertyValuesByName(propertyName) {

    const propertyValues = this.propertyNameValuesMap[propertyName];

    if (this.disabled === false && propertyValues !== void 0) {
      return propertyValues;
    }

    this.propertyNameValuesMap[propertyName] = await serverInterface.startup.analytics.getUserPropertyValuesByName(propertyName);

    return this.propertyNameValuesMap[propertyName];

  }

}

export default Cache;